export default {

	addToCompareList( state, data ){

		if (state[data.listType]) {

			state[data.listType].push( data.id )
		}
	}
    
}